/*
  Elilhaam visual search (search by photo)
  Opens a panel where customers upload, take or paste a photo of a dress.
  The photo is resized in the browser, sent to the visual search API, and the
  matching products are shown with live price and availability from Shopify.
*/
(function () {
  'use strict';

  var CFG = window.ElilhaamVisualSearch || {};
  var MAX_SIDE = 640;
  var overlay = null;
  var els = {};
  var busy = false;

  var TEXT = {
    title: 'Search by photo',
    sub: 'Upload a photo of a dress you love and we will find the closest styles in our collection.',
    drop: 'Drop a photo here, paste it, or',
    choose: 'Upload or take a photo',
    hint: 'JPG, PNG or WEBP. For best results use a photo showing the full dress.',
    searching: 'Finding similar styles',
    results: 'Similar styles',
    none: 'We could not find a close match. Try a clearer photo of the full dress.',
    failed: 'Something went wrong. Please try again.',
    badImage: 'This file could not be read as a photo. Please try a JPG or PNG.',
    another: 'Try another photo',
    soldOut: 'Sold out',
    close: 'Close'
  };

  var CAMERA_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 8.5A1.5 1.5 0 0 1 5.5 7h2.1l1.4-2h6l1.4 2h2.1A1.5 1.5 0 0 1 20 8.5v9a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 4 17.5z"/><circle cx="12" cy="13" r="3.6"/></svg>';

  function el(tag, cls, html) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (html !== undefined) n.innerHTML = html;
    return n;
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function build() {
    if (overlay) return;
    overlay = el('div', 'vs-overlay');
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', TEXT.title);

    var panel = el('div', 'vs-panel');
    var close = el('button', 'vs-close', '&times;');
    close.type = 'button';
    close.setAttribute('aria-label', TEXT.close);
    close.addEventListener('click', closePanel);

    var title = el('h2', 'vs-title', esc(TEXT.title));
    var sub = el('p', 'vs-sub', esc(TEXT.sub));

    var drop = el('label', 'vs-drop');
    var input = document.createElement('input');
    input.type = 'file';
    input.accept = 'image/*';
    input.hidden = true;
    drop.innerHTML = CAMERA_SVG +
      '<div>' + esc(TEXT.drop) + '</div>' +
      '<span class="vs-btn">' + esc(TEXT.choose) + '</span>' +
      '<div class="vs-hint">' + esc(TEXT.hint) + '</div>';
    drop.appendChild(input);

    var query = el('div', 'vs-query');
    var queryImg = document.createElement('img');
    queryImg.alt = '';
    var queryRight = el('div');
    var status = el('div', 'vs-status');
    var again = el('button', 'vs-btn vs-btn--ghost', esc(TEXT.another));
    again.type = 'button';
    again.style.marginTop = '10px';
    again.addEventListener('click', function () { input.value = ''; input.click(); });
    queryRight.appendChild(status);
    queryRight.appendChild(again);
    query.appendChild(queryImg);
    query.appendChild(queryRight);

    var error = el('div', 'vs-error');
    var grid = el('div', 'vs-grid');

    panel.appendChild(close);
    panel.appendChild(title);
    panel.appendChild(sub);
    panel.appendChild(drop);
    panel.appendChild(query);
    panel.appendChild(error);
    panel.appendChild(grid);
    overlay.appendChild(panel);
    document.body.appendChild(overlay);

    els = { panel: panel, drop: drop, input: input, query: query, queryImg: queryImg, status: status, again: again, error: error, grid: grid };

    overlay.addEventListener('click', function (e) { if (e.target === overlay) closePanel(); });
    input.addEventListener('change', function () {
      if (input.files && input.files[0]) handleFile(input.files[0]);
    });
    ['dragenter', 'dragover'].forEach(function (t) {
      drop.addEventListener(t, function (e) { e.preventDefault(); drop.classList.add('vs-drag'); });
    });
    ['dragleave', 'drop'].forEach(function (t) {
      drop.addEventListener(t, function (e) { e.preventDefault(); drop.classList.remove('vs-drag'); });
    });
    drop.addEventListener('drop', function (e) {
      var f = e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0];
      if (f) handleFile(f);
    });
  }

  function openPanel() {
    build();
    overlay.classList.add('vs-open');
    document.documentElement.style.overflow = 'hidden';
    document.addEventListener('keydown', onKey);
    document.addEventListener('paste', onPaste);
  }

  function closePanel() {
    if (!overlay) return;
    overlay.classList.remove('vs-open');
    document.documentElement.style.overflow = '';
    document.removeEventListener('keydown', onKey);
    document.removeEventListener('paste', onPaste);
  }

  function onKey(e) {
    if (e.key === 'Escape') closePanel();
  }

  function onPaste(e) {
    var items = (e.clipboardData && e.clipboardData.items) || [];
    for (var i = 0; i < items.length; i++) {
      if (items[i].type && items[i].type.indexOf('image/') === 0) {
        var f = items[i].getAsFile();
        if (f) { e.preventDefault(); handleFile(f); return; }
      }
    }
  }

  function showError(msg) {
    els.error.textContent = msg || '';
  }

  function setStatus(html) {
    els.status.innerHTML = html;
  }

  // Resize to max 640px and re-encode as JPEG (smaller upload, works for any photo the browser can open).
  function fileToDataUrl(file) {
    return new Promise(function (resolve, reject) {
      var url = URL.createObjectURL(file);
      var img = new Image();
      img.onload = function () {
        try {
          var scale = Math.min(1, MAX_SIDE / Math.max(img.naturalWidth, img.naturalHeight));
          var w = Math.max(1, Math.round(img.naturalWidth * scale));
          var h = Math.max(1, Math.round(img.naturalHeight * scale));
          var canvas = document.createElement('canvas');
          canvas.width = w;
          canvas.height = h;
          var ctx = canvas.getContext('2d');
          ctx.fillStyle = '#ffffff';
          ctx.fillRect(0, 0, w, h);
          ctx.drawImage(img, 0, 0, w, h);
          URL.revokeObjectURL(url);
          resolve(canvas.toDataURL('image/jpeg', 0.86));
        } catch (err) {
          URL.revokeObjectURL(url);
          reject(err);
        }
      };
      img.onerror = function () {
        URL.revokeObjectURL(url);
        reject(new Error('decode'));
      };
      img.src = url;
    });
  }

  function handleFile(file) {
    if (busy) return;
    showError('');
    fileToDataUrl(file).then(function (dataUrl) {
      search({ image: dataUrl }, dataUrl);
    }).catch(function () {
      showError(TEXT.badImage);
    });
  }

  function searchByImageUrl(imageUrl, exclude) {
    openPanel();
    var abs = imageUrl.indexOf('//') === 0 ? 'https:' + imageUrl : imageUrl;
    search({ imageUrl: abs, exclude: exclude || '' }, abs);
  }

  function search(payload, previewSrc) {
    if (!CFG.endpoint || CFG.endpoint.indexOf('YOUR-SUBDOMAIN') !== -1) {
      showError('Visual search is not configured yet.');
      return;
    }
    busy = true;
    els.drop.style.display = 'none';
    els.query.style.display = 'flex';
    els.queryImg.src = previewSrc;
    els.again.style.display = 'none';
    els.grid.innerHTML = '';
    setStatus('<span class="vs-spinner"></span>' + esc(TEXT.searching));

    payload.limit = CFG.limit || 24;
    fetch(CFG.endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) throw new Error((data && data.error) || 'HTTP ' + res.status);
        return data;
      });
    }).then(function (data) {
      return loadProducts((data && data.results) || []);
    }).then(function (products) {
      busy = false;
      els.again.style.display = '';
      if (!products.length) {
        setStatus(esc(TEXT.none));
        return;
      }
      setStatus(esc(TEXT.results) + ' (' + products.length + ')');
      render(products);
    }).catch(function () {
      busy = false;
      els.again.style.display = '';
      setStatus('');
      showError(TEXT.failed);
    });
  }

  function productUrl(handle) {
    var root = CFG.root || '/';
    if (root.charAt(root.length - 1) !== '/') root += '/';
    return root + 'products/' + encodeURIComponent(handle);
  }

  // Live price and availability; products that are no longer published are skipped.
  function loadProducts(results) {
    var out = new Array(results.length);
    var index = 0;
    function worker() {
      if (index >= results.length) return Promise.resolve();
      var i = index++;
      var r = results[i];
      return fetch(productUrl(r.handle) + '.js', { headers: { Accept: 'application/json' } })
        .then(function (res) { return res.ok ? res.json() : null; })
        .then(function (p) {
          if (p) out[i] = { result: r, product: p };
        })
        .catch(function () {})
        .then(worker);
    }
    var runners = [];
    for (var k = 0; k < 6; k++) runners.push(worker());
    return Promise.all(runners).then(function () {
      return out.filter(Boolean);
    });
  }

  function money(cents) {
    var value = (cents || 0) / 100;
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || CFG.currency || 'AED';
    try {
      return new Intl.NumberFormat(CFG.locale || document.documentElement.lang || 'en', {
        style: 'currency',
        currency: currency,
        maximumFractionDigits: value % 1 === 0 ? 0 : 2
      }).format(value);
    } catch (e) {
      return currency + ' ' + value.toFixed(2);
    }
  }

  function sizedImage(src, width) {
    if (!src) return '';
    var u = src.indexOf('//') === 0 ? 'https:' + src : src;
    return u + (u.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  function render(items) {
    var html = '';
    items.forEach(function (item) {
      var p = item.product;
      var img = p.featured_image || (p.images && p.images[0]) || item.result.image || '';
      html += '<a class="vs-card" href="' + esc(productUrl(p.handle)) + '">' +
        '<div class="vs-card__img">' +
          (img ? '<img loading="lazy" src="' + esc(sizedImage(img, 500)) + '" alt="' + esc(p.title) + '">' : '') +
          (p.available ? '' : '<span class="vs-badge">' + esc(TEXT.soldOut) + '</span>') +
        '</div>' +
        '<div class="vs-card__vendor">' + esc(p.vendor) + '</div>' +
        '<div class="vs-card__title">' + esc(p.title) + '</div>' +
        '<div class="vs-card__price">' + esc(money(p.price)) + '</div>' +
      '</a>';
    });
    els.grid.innerHTML = html;
  }

  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target.closest('[data-visual-search-open],[data-visual-search-image]') : null;
    if (!t) return;
    e.preventDefault();
    if (t.hasAttribute('data-visual-search-image')) {
      searchByImageUrl(t.getAttribute('data-visual-search-image'), t.getAttribute('data-visual-search-exclude'));
    } else {
      openPanel();
      if (els.drop && !busy) {
        els.drop.style.display = '';
        els.query.style.display = 'none';
        els.grid.innerHTML = '';
        showError('');
      }
    }
  });

  if (window.location.hash === '#visual-search') {
    document.addEventListener('DOMContentLoaded', openPanel);
  }

  window.ElilhaamVisualSearch = CFG;
  CFG.open = openPanel;
})();
